<template>
  <div id="header">

    <span>小数答题管理系统</span>
    <div class="userOpreation">
      <span class="userName">{{userName}}</span>
      <el-button
        type="text"
        @click="exit"
      >退出<i class="el-icon-right el-icon--right"></i></el-button>
    </div>
  </div>
</template>

<script>
import { JumpToLogin } from '../../../utils/utils'
export default {
  data() {
    return {
      userName: window.sessionStorage.getItem('loginuser')
        ? JSON.parse(window.sessionStorage.getItem('loginuser')).name
        : ''
    }
  },
  methods: {
    exit() {
      this.$confirm('确定退出登录？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          JumpToLogin()
        })
        .catch(() => {})
    }
  }
}
</script>
<style  lang='scss'>
#header {
  height: 100%;
  width: 100%;
  text-align: center;
  padding: 0 20px;
  color: #fff;
  line-height: 60px;
  font-weight: 700;
  font-size: 20px;
  background-color: #3C50E0;
  box-sizing: border-box;
  .userOpreation {
    float: right;
    height: 100%;
    display: flex;
    text-align: left;
    font-size: 14px;
    font-weight: normal;
    .userName {
      margin-right: 20px;
    }
    .el-button--text {
      color: #fff;
      font-size: 14px;
    }
    .el-icon-right {
      font-weight: bold;
    }
  }
}
</style>
